import { warehouseLineAllocationApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const WAREHOUSE_ALLOCATION_ACTION_TYPE = createNamedActions('warehouseAllocations', {
  GET_ALLOCATIONS_BY_LINE: 'GET_ALLOCATIONS_BY_LINE',
  GET_ALLOCATION: 'GET_ALLOCATION',
  CREATE_ALLOCATION: 'CREATE_ALLOCATION',
  DELETE_ALLOCATION: 'DELETE_ALLOCATION',
  TRANSITION_ALLOCATION_STATUS: 'TRANSITION_ALLOCATION_STATUS',
  GET_CURTAILMENTS: 'GET_CURTAILMENTS',
  CREATE_CURTAILMENT: 'CREATE_CURTAILMENT',
  RECORD_CURTAILMENT_PAYMENT: 'RECORD_CURTAILMENT_PAYMENT',
  GET_CURTAILMENT_RULES: 'GET_CURTAILMENT_RULES',
  MANAGE_CURTAILMENT_RULES: 'MANAGE_CURTAILMENT_RULES',
  GET_ALLOCATION_BY_LOAN: 'GET_ALLOCATION_BY_LOAN',
  CLEAR_ALLOCATIONS: 'CLEAR_ALLOCATIONS',
});

export const getAllocationsByLineAction = catchAsyncActionError(({ lineId }) => async dispatch => {
  const { data } = await warehouseLineAllocationApi.getAllocationsByLine({ lineId });

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_ALLOCATIONS_BY_LINE,
    payload: data,
    meta: { lineId },
  });
});

export const getAllocationAction = catchAsyncActionError(({ allocationId }) => async dispatch => {
  const { data } = await warehouseLineAllocationApi.getAllocation({ allocationId });

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_ALLOCATION,
    payload: data,
  });
});

export const deleteAllocationAction = catchAsyncActionError(
  ({ allocationId }) =>
    async dispatch => {
      await warehouseLineAllocationApi.deleteAllocation({ allocationId });

      return dispatch({
        type: WAREHOUSE_ALLOCATION_ACTION_TYPE.DELETE_ALLOCATION,
        meta: { allocationId },
      });
    },
);

export const transitionAllocationStatusAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseLineAllocationApi.transitionAllocationStatus(params);

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.TRANSITION_ALLOCATION_STATUS,
    payload: data,
  });
});

export const getCurtailmentsAction = catchAsyncActionError(({ allocationId }) => async dispatch => {
  const { data } = await warehouseLineAllocationApi.getCurtailments({ allocationId });

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_CURTAILMENTS,
    payload: data,
    meta: { allocationId },
  });
});

export const createCurtailmentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseLineAllocationApi.createCurtailment(params);

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.CREATE_CURTAILMENT,
    payload: data,
  });
});

export const recordCurtailmentPaymentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseLineAllocationApi.recordCurtailmentPayment(params);

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.RECORD_CURTAILMENT_PAYMENT,
    payload: data,
  });
});

export const getCurtailmentRulesAction = catchAsyncActionError(({ lineId }) => async dispatch => {
  const { data } = await warehouseLineAllocationApi.getCurtailmentRules({ lineId });

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.GET_CURTAILMENT_RULES,
    payload: data,
    meta: { lineId },
  });
});

export const manageCurtailmentRulesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseLineAllocationApi.manageCurtailmentRules(params);

  return dispatch({
    type: WAREHOUSE_ALLOCATION_ACTION_TYPE.MANAGE_CURTAILMENT_RULES,
    payload: data,
  });
});

export const clearAllocationsAction = () => ({
  type: WAREHOUSE_ALLOCATION_ACTION_TYPE.CLEAR_ALLOCATIONS,
});
